export default function leaderboardDataSelector(func) {
  return func((state) => state.leaderboardReducer);
}
